import queryString from 'query-string';

import queryStringOptions from '@/constants/queryStringOptions';

/**
 * Resolves a page's starting filters: query params first, then whatever the
 * user last used, then defaults.
 *
 * Saved filters are passed in rather than read from storage here, so the
 * caller decides where they come from (they are a server-backed user setting).
 */
const getInitialFilters = <T>({
  storedFilters,
  defaultFilters,
  searchString
}: {
  defaultFilters: Partial<T>;
  storedFilters?: Partial<T>;
  searchString?: string;
}): Partial<T> => {
  // A link someone was sent wins over what they last used.
  if (searchString) {
    return queryString.parse(searchString, queryStringOptions) as Partial<T>;
  }

  // A cached setting that failed to parse comes back as the raw string, so the
  // shape is checked here rather than assumed.
  const isFilterObject =
    typeof storedFilters === 'object' && storedFilters !== null && !Array.isArray(storedFilters);

  if (isFilterObject && Object.keys(storedFilters).length > 0) {
    return storedFilters;
  }

  return defaultFilters;
};

export default getInitialFilters;
